import { Container } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './UsersHome.css';

function UsersHome() {
  return (
    <Container id='HomeWrapper'>
    <h5 className='titleContainerStyle'>Головна</h5>
        <Row className='row-1 row-xl-1 row-lg-1 row-md-2 row-sm-4 rowStyle'>
            <Col className='col-12 col-xl-3 col-lg-3 col-md-6 col-sm-12 borderRight'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Наші соціальні мережі</h5>
                    <a href="https:/kai.ua" target='_blank' className='linkStyle'>
                        Перейти на KAI.UA
                    </a>
                    <a href="https://www.youtube.com/channel/UCUVBgI8vF5j1rgStMwazCuA" target='_blank' className='linkStyle'>
                        Відвідати Ютуб канал 
                    </a>
                    <a href="https://www.facebook.com/k.document" target='_blank' className='linkStyle'>
                        Facebook сторінка 
                    </a>
                </div>
            </Col>
            <Col className='col-12 col-xl-3 col-lg-3 col-md-6 col-sm-12 borderRight'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Посібники та інструкції</h5>
                    <NavLink to="/instructions" exact className="nav-item StyleBtnInstructions" activeClassName="active">
                        Інструкції
                    </NavLink>
                    {/* <a href="#" target='_blank' className='linkStyle'>
                        Відеоінструкції
                    </a> */}
                    <NavLink to="/manuals" exact className="nav-item StyleBtnInstructions" activeClassName="active">
                        Посібники по продуктах
                    </NavLink>
                </div>
            </Col>
            <Col className='col-12 col-xl-3 col-lg-3 col-md-6 col-sm-12 borderRight'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Контакти та звернення</h5>
                    <a href="https://kai.ua/contacts" target='_blank' className='StyleBtnInstructions nav-item'>
                        Контакти
                    </a>
                </div>
            </Col>
            <Col className='col-12 col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Керування</h5>
                    <NavLink to="/request" exact className="nav-item StyleBtnHomePage" activeClassName="active">
                        Створити новий запит
                    </NavLink>
                    <NavLink to="/user" exact className="nav-item StyleBtnHomePage" activeClassName="active">
                        Відкрити профіль
                    </NavLink>
                </div>
            </Col>
        </Row>

    </Container>
  );
}

export default UsersHome;
